const b2bJa = {
  ja: {
    nb: {
      new_business: '新規お申込',
      service_records: 'サービス記録',
      clients: 'お客様',
      reports: 'レポート',
      commissions: 'サポート費明細',
      my_profile: 'パートナー情報',
      keywords: 'お客様番号 / プラン番号 / お客様名 / パートナー',
      insurance_plan: '保険プラン',
      investment_link: 'ユニットリンク',
      fund_platform: 'ファンドプラットフォーム',
      transfer_in: 'トランスファーイン',
      private_bank: 'プライベートバンク',
      trust: '信託プラン',
      legend: '完成段階',
      stage_1: 'ステージ1',
      stage_2: 'ステージ2',
      stage_3: 'ステージ3',
      stage_4: 'ステージ4',
      stage_5: 'ステージ5',
      stage_6: 'ステージ6',
      stage_7: 'ステージ7',
      stage_other: 'その他',
      stage_1_desc: '{{siteShortName}} 申込書類受領',
      stage_2_desc: '不備あり（{{siteShortName}} チェック段階）',
      stage_3_desc: '商品プロバイダーへ申込書提出',
      stage_4_desc: '不備あり（商品プロバイダーチェック段階）',
      stage_5_desc: '不備解消。商品プロバイダーからの証券発行待ち',
      stage_6_desc: '{{siteShortName}} 証券受領',
      stage_7_desc: '{{siteShortName}} 証券受領確認書受領 / Account Opened',
      stage_other_desc: 'お申込キャンセル',
      oaa: 'Online Application Assistance',
      new_policy_detail: '申込プラン詳細',
      service_record_detail: 'サービス記録詳細',
      statement: '運用状況報告書',
      close: '閉じる',
      table_fields: {
        policy_no: 'お申込／証券番号 *',
        client: 'お客様名',
        insured: '被保険者',
        modal_premium: '支払い金額',
        plan_start_date: '実行日',
        app_rec_date: 'お申込書類受領日*',
        stage: '完成段階*',
        consultant: 'パートナー*',
        details: '詳細',
      },
    },
    clients: {
      keywords: 'お客様名  /  お客様番号  /  プラン番号  /  プラン名  /  パートナー',
      exclude_policy_status: '検索対象より除外',
      fund_keywords: 'ファンド名  /  ファンドコード',
      client_product_type: '商品タイプ',
      client_detail: '客戶資料',
      documents: '文件',
      table_fields: {
        client: 'お客様名 *',
        policy_no: 'お申込／証券番号 *',
        insured: '被保険者',
        modal_premium: '支払い金額',
        status: '現状*',
        consultant: 'パートナー*',
        details: '詳細',
      },
    },
    sr: {
      keywords: 'プラン番号 / お客様名',
      export_excel: 'エクセル表示',
      sr_all: ' - 全て - ',
      sr_status: '手続状況',
      sr_type: '手続タイプ',
      table_fields: {
        policy_no: 'お申込／証券番号 *',
        client: 'お客様名',
        insured: '被保険者',
        sr_type: '手続タイプ',
        sr_status: '手続状況*',
        created_date: '作成日*',
        complete_date: '完了日*',
        consultant: 'パートナー*',
        details: '詳細',
      },
    },
    my_profile: {
      title: 'パートナー情報',
      subtitle: '下記情報は {{siteName}} での登録内容です',
      name: 'パートナー名',
      code: 'パートナー番号',
      op_email: '一般事項用メールアドレス',
      ac_email: 'サポート費用メールアドレス',
      contract_addr: '現住所',
      corr_addr: '通知先住所',
      remark: '上記情報の変更をご希望の場合は「サポーターコーナー」より情報変更依頼書を入手の上、{{siteName}} までお送りください',
    },
    commission: {
      issue_month: '明細書発行月',
      pdf_version: 'PDF版',
    },
    onlineAppl: {
      producer_info: 'イントロデューサー情報および申請内容',
      information: 'Information',
      save: 'Save',
      submit: 'Submit',
    },
    layout: {
      welcome: 'ようこそ, ',
    },
    statement: {
      provider_statement: '取引履歴／商品プロバイダー発信ステートメント',
      other_policies: 'その他ご契約プラン',
      choose_month: 'ご覧になりたい月を選択 *',
      choose_currency: 'Choose Currency',
      pdf_version: 'PDF版',
      last_6_month_remarks: '* 過去６ヵ月の運用報告書をダウンロードできます',
    },
  },
};

export default b2bJa;
